import React, { useState } from 'react'
import {Button,Modal} from 'react-bootstrap'

function ModalZeroIncident () {
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div>
            <Button variant="primary" onClick={handleShow}>
                Learn more
            </Button>
            {/* <a href="/" className="btn btn-link right-icon" >Learn more <i className="icon icon-minimal-right"></i></a> */}
    
            <Modal show={show} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Less to Zero Incident</Modal.Title>
            </Modal.Header>
            <Modal.Body>Solusi yang dapat mendukung terciptanya lingkungan kerja yang lebih aman dengan menghindari cedera serius dan mencapai Zero Fatalities. 
                Dapat mencakup pemanfaatan teknologi terbaru seperti robotics, virtual reality (VR), ataupun augmented reality (AR). 
                Dapat berupa solusi yang digunakan oleh pekerja untuk menjalankan tugas dengan lebih aman, tetap selamat, dan kinerja tinggi. 
                Ataupun solusi yang dapat digunakan oleh manajemen untuk menciptakan dan mempertahankan lingkungan kerja yang lebih aman.</Modal.Body>
            <Modal.Footer>
                <a 
                style={{"color":"#fff"}}
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/watch?v=BOfh-VQHqIE">
                    <button className="btn btn-primary" >
                        Keynotes Video
                    </button>
                </a>
            </Modal.Footer>


            </Modal>
        </div>
    );
}


export default ModalZeroIncident
